module.exports = __webpack_public_path__ + "static/img/yagi_06.0804fb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yagi_06.jpg
// module id = ii7J
// module chunks = 0